import { render, staticRenderFns } from "./DashboardRiskmatrixChart.vue?vue&type=template&id=53d70ec0&scoped=true"
import script from "./DashboardRiskmatrixChart.vue?vue&type=script&lang=js"
export * from "./DashboardRiskmatrixChart.vue?vue&type=script&lang=js"
import style0 from "./DashboardRiskmatrixChart.vue?vue&type=style&index=0&id=53d70ec0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53d70ec0",
  null
  
)

export default component.exports